import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { UserService } from '../service/user.service';
import { Router } from '@angular/router';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoginResponse } from '../security/login-response';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm!: FormGroup;
  loginError!: boolean;
  submitting = false;
  baseUrl = environment.lvConnectBaseUrl; //http://localhost:4200/
  keycloakUrl = environment.keycloakUrl;

  loginUrl = this.keycloakUrl + "/realms/Langues%20Vivantes/protocol/openid-connect/auth"
  clientId = environment.keycloakClientId;
  redirectUri = encodeURIComponent(this.baseUrl + "/redirecting");
  responseType = "code";
  scope = "openid profile";

  constructor(
    private route: Router,
    private loginService: LoginService,
    private favicon: FaviconService
  ) {
    this.loginService.activatedNavigationComponent = false;
    this.loginService.isLoginComponent = true;
    this.favicon.sbms();
    this.redirectToKeycloak();
  }

  ngOnInit() {
  }

  redirectToKeycloak() {
    let requestUri = this.loginUrl + "?client_id=" + this.clientId + "&redirect_uri=" + this.redirectUri + "&response_type=" + this.responseType + "&scope=" + this.scope;
    console.log("redirect uri: " + this.redirectUri);
    window.location.href = requestUri;
  }

}
